module.exports = __webpack_public_path__ + "img/nlic_gallery7.74868090.jpg";